// Utils
import { assert } from '../../others';
/**
 * Determines if a given object or array is empty
 *
 * @param {object} value
 *
 * @return {boolean}
 */
export var isObjectOrArrayEmpty = function (value) {
    assert(typeof value === 'object', 'Value given must be an object');
    if (value === null
        || (Array.isArray(value) && value.length === 0)
        || Object.keys(value).length === 0) {
        return true;
    }
    return false;
};
//# sourceMappingURL=isObjectOrArrayEmpty.js.map